
import { defineComponent, SetupContext, ref, computed } from "vue";
import NativeClient from "@/client/native-client";
import { PantryVirtualData, PLATE_DISPLAY_FORMAT, REM_VIRTUAL_LIST_PADDING, REM_VIRTUAL_LIST_FOOD_PADDING } from "@/types/pantry";
import PantryUtil from "@/utils/pantry-util";
import { convertRemToPx } from "@/utils/common-utils";
export default defineComponent({
  name: "PantryVirtualListItem",
  components: {},
  props: {
    id: {
      type: Number,
      default: 0
    },
    data: {
      type: PantryVirtualData,
      default: null,
      required: true
    },
    selectMode: {
      type: Boolean,
      default: false,
      required: true
    },
    linePosition: {
      type: Number,
      default: 0,
      required: true
    }
  },
  setup(props, context: SetupContext) {
    const item = ref<HTMLDivElement>();
    const loadError = ref(false);
    const isChecked = ref(false);
    NativeClient.sendDebugLog(
      "PantryVirtualListItem data=" + JSON.stringify(props.data)
    );
    const isPlateEmpty = () => {
      let result = false;
      if (props.data && props.data.info && props.data.info.plate != null) {
        if (props.data.info.pantryPlateId == null) {
          result = true;
        }
      }
      return result;
    };
    const isShowImage = () => {
      if (loadError.value) {
        return false;
      }
      if (props.data != null && props.data.info != null) {
        return true;
      }
      return false;
    };
    const getImage = () => {
      return props.data != null &&
        props.data.info != null &&
        props.data.info.icon
        ? props.data.info.icon
        : "";
    };
    const onImageError = (event: Event) => {
      NativeClient.sendDebugLog("PantryVirtualListItem onImageError");
      if (event.target) {
        loadError.value = true;
      }
    };
    const getName = () => {
      let name =
        props.data != null && props.data.info != null && props.data.info.name
          ? props.data.info.name
          : "";
      if (name.length > 10) {
        name = name.substring(0, 9) + "...";
      }
      return name;
    };
    const getBackgroundImage = () => {
      let result = "none";
      if (
        props.data != null &&
        props.data.info != null &&
        props.data.info.plate != null &&
        props.data.info.plate.unit != null
      ) {
        const plate = props.data.info.plate;
        const value = plate.item != null ? plate.item.value : 0;
        let barValue = 0;
        if (plate.unit.displayFormat == PLATE_DISPLAY_FORMAT.VALUE) {
          barValue =
            (plate.unit.unitWeight * value * 100) / plate.unit.fullWeight;
        } else {
          barValue = value;
        }
        if (barValue >= 100) {
          // Android端末で100の場合に隙間ができる現象の対応
          barValue = 101;
        }
        const barPersent = barValue + "%";
        NativeClient.sendDebugLog(
          "PantryVirtualListItem getBackgroundImage barValue=" + barValue
        );
        result =
          "radial-gradient(#ffffff 60%, transparent 30%), conic-gradient(var(--main-thinline-color) 0% " +
          barPersent +
          ", #dddddd " +
          barPersent +
          " 100%)";
        NativeClient.sendDebugLog(
          "PantryVirtualListItem getBackgroundImage result=" + result
        );
      }
      return result;
    };
    const isShowCheck = () => {
      // return isChecked.value && props.selectMode;
      return (props.data && props.data.checked && props.selectMode);
    };
    const clickCheck = () => {
      if (props.data) {
        context.emit("select-check", props.data, !props.data.checked);
      }
    };
    const isShowPlateError = () => {
      let result = false;
      if (
        props.data != null &&
        props.data.info != null
      ) {
        result = PantryUtil.isShowPlateError(props.data.info);
      }
      return result;
    };
    const styleItem = computed(() => {
      const itemAreaWidth = window.innerWidth - convertRemToPx(REM_VIRTUAL_LIST_PADDING * 2) - convertRemToPx(REM_VIRTUAL_LIST_FOOD_PADDING * 2);
      const itemWidth = itemAreaWidth / 3;
      let padding = 0;
      const id = props.id;
      const paddingPosition = id % 5;
      NativeClient.sendDebugLog(
        "PantryVirtualListItem styleItem id=" + id + " paddingPosition=" + paddingPosition
      );
      if (paddingPosition == 0 || paddingPosition == 1 || paddingPosition == 3) {
        padding = convertRemToPx(REM_VIRTUAL_LIST_FOOD_PADDING);
      }
      const width = itemWidth + padding;
      return { 'height': itemWidth + "px", 'width': width + "px", 'padding-right': padding + "px" };
    });
    const styleCircleItem = computed(() => {
      const itemAreaWidth = window.innerWidth - convertRemToPx(REM_VIRTUAL_LIST_PADDING * 2) - convertRemToPx(REM_VIRTUAL_LIST_FOOD_PADDING * 2);
      const itemWidth = itemAreaWidth / 3;
      const circleWidth = itemWidth * convertRemToPx(8.8) / convertRemToPx(11.2);
      const positon = (itemWidth - circleWidth) / 2;
      return { 'height': circleWidth + "px", 'width': circleWidth + "px", 'top': positon + "px", 'left': positon + "px" };
    });

    return {
      getImage,
      onImageError,
      isShowImage,
      loadError,
      getName,
      getBackgroundImage,
      clickCheck,
      isChecked,
      isShowCheck,
      isPlateEmpty,
      item,
      isShowPlateError,
      styleItem,
      styleCircleItem
    };
  }
});
